jQuery(document).ready(function ($) {

	const industriesTabs = document.querySelectorAll('.industries-tab-list__item');
	const smallBlockItem = document.querySelectorAll('.small-blocks-list--item');

	(function(){
		let speed = 2; // Скорость скролла.

		let scroll = document.querySelector('.industries-tab-list');

		let left = 0; // отпустили мышку - сохраняем положение скролла
		let drag = false;
		let coorX = 0; // нажали мышку - сохраняем координаты.

		scroll.addEventListener('mousedown', function(e) {
			drag = true;
			coorX = e.pageX - this.offsetLeft;
		});
		document.addEventListener('mouseup', function() {
			drag = false;
			left = scroll.scrollLeft;
		});
		scroll.addEventListener('mousemove', function(e) {
			if (drag) {
				this.scrollLeft = left - (e.pageX - this.offsetLeft - coorX)*speed;
			}
		});

	})();

	//slider
	let slickblock = ()=> {$( '.industry-tab-slider' ).slick( {
			dots: false,
			arrows: true,
			speed: 500,
			slidesToShow: 5,
			slidesToScroll: 1,
			infinity: false,
			focusOnSelect: true,
			touchMove: true,
			swipeToSlide: true,
			prevArrow: '<button type="button" class="prev-button"></button>',
			nextArrow: '<button type="button" class="next-button"></button>',
			responsive: [
				{
					breakpoint: 1920,
					settings: {
						slidesToShow: 4
					}
				},
				{
					breakpoint: 1680,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 570,
					settings: {
						slidesToShow: 1
					}
				}
			]
		} );}
	slickblock();

	$(document).on('click', '.industries-tab-list', function (e) {

		const current = e.target;

		if (current.classList.contains('active')) {
			let tab_id = current.getAttribute('data-tab');
			let currentTab = $('#' + tab_id)[0];
			if ( currentTab ) {
				let topPosition = currentTab.offsetTop -120;
				window.scroll({
					top: topPosition,
					behavior: 'smooth'
				});
			}
			return true;
		} else {
			industriesTabs.forEach((elem)=>{
				if (elem.classList.contains('active')) {
					elem.classList.remove('active');
				}
				$( '.industry-tab-slider' ).slick('unslick');

			})

			current.classList.add('active');

			slickblock();
			let tab_id = current.getAttribute('data-tab');
			$('.tab-content').removeClass('current');

			$('#' + tab_id).addClass('current');
			let currentTab = $('#' + tab_id)[0];
			if(currentTab) {
				let topPosition = currentTab.offsetTop -120;
				window.scroll({
					top: topPosition,
					left: 0,
					behavior: 'smooth'
				});

				let bigNumber = currentTab.querySelector('.number');
				if (bigNumber) {
					if ( !bigNumber.classList.contains('moving-number') ) {
						setTimeout(bigNumber.classList.add('moving-number'), 3000);
					}
				}
			}
		}
	});


	//function for fixe tabs
	function fixedAnchorTab() {
		const elem = document.querySelector('.industries-section');
		const elemChild = document.querySelector('.tabs-content-container');
		const ssSlider = document.querySelector('.stories-section');
		let headerHeight = document.querySelector('.header').offsetHeight;
		const top = +elem.getBoundingClientRect().top + elem.querySelector('.title-wrapper').offsetHeight - headerHeight;
		const bottom = elemChild.getBoundingClientRect().height + top + ssSlider.getBoundingClientRect().height;

		if (top < 0 && bottom > 0) {
			elem.querySelector('.tabs-container').classList.add('fixed-dropdown');
			elem.querySelector('.tabs-container').classList.remove('fixed-dropdown-animate');
		} else if (bottom < 0) {
			if ( elem.querySelector('.tabs-container').classList.contains('fixed-dropdown') ) {
				elem.querySelector('.tabs-container').classList.add('fixed-dropdown-animate');
			}
		} else {
			if ( elem.querySelector('.tabs-container').classList.contains('fixed-dropdown') ) {
				elem.querySelector('.tabs-container').classList.remove('fixed-dropdown');
			}
		}
	}

	window.addEventListener('scroll', fixedAnchorTab);


	const options = {
		root: null,
		rootMargin: '-10px 0px -85% 0px',
		threshold: 0,
	}

	const industrySection = document.querySelector('.industries-section');
	const callback = function(entries, observer) {
		entries.forEach(entry => {
			if ( entry.isIntersecting ) {
				$('.tab-content.current .number').addClass('moving-number');
			} else {
				$('.tab-content.current .number').removeClass('moving-number');
			}
		})
	};
	const observer = new IntersectionObserver(callback, options);
	observer.observe( industrySection );



	//small white blocks
	let observer2 = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if ( entry.isIntersecting ) {

				let currentSmallBlock = $(entry.target).find('.small-blocks-list--item');
				$(currentSmallBlock).addClass('visible-white-block');
			} else {
				let currentSmallBlock = $(entry.target).find('.small-blocks-list--item');
				if ($(currentSmallBlock).hasClass('visible-white-block')) {
					$(currentSmallBlock).removeClass('visible-white-block');
				}
			}
		})
	}, {
		root: null,
		rootMargin: '0px 0px 0px 0px',
		threshold: 0,
	})

	document.querySelectorAll('.small-blocks-wrapper').forEach(li => observer2.observe(li));

});